import React from 'react';

import AgConfirmationModal from '@/components/common/ModalWindow/AgConfirmationModal';

interface IRollOverModal {
  onClose: () => void;
  onConfirm: () => void;
}
function RollOverDateModal({ onClose, onConfirm }: IRollOverModal) {
  return (
    <AgConfirmationModal
      isOpen={true}
      title="You are about to rollover the Contract End Date"
      onClose={onClose}
      onConfirm={onConfirm}
      contentStyle={{ width: 600 }}
    >
      You have added an active Contract Line to a contract which has status as DNR. <br />
      This will renew, and reactivate the contract.
    </AgConfirmationModal>
  );
}

export default RollOverDateModal;